export default {
  namespaced: true,
  state: { display: true, mini: true, items: [] },
  actions: {
    toggle({ commit }) {
      commit("TOGGLE");
    },
    toggleMini({ commit }) {
      commit("TOGGLE_MINI");
    },
    setMenu({ commit }, user) {
      commit("SETMENU", user);
    }
  },
  getters: {
    status: state => {
      return state.display;
    }
  },
  mutations: {
    TOGGLE(state) {
      state.display = !state.display;
    },
    TOGGLE_MINI(state) {
      state.mini = !state.mini;
    },
    SETMENU(state, payload) {
      state.items = payload;
    }
  }
};
